<template>
    <div>
    <app-header />
    <div class="zhanshibox3_25">
      <div class="zhanshi3_25">
        <div class="toptitle">{{topicname}}</div>
        <div class="toptitleul3_26" style="text-align: center;">
          <div style="display: inline-block;">
            <div :class="val.deafultChoose?'liinttrue':'liintfalse'" v-for="val in msg" @click="tiao(val.funcationType)">{{val.funcationName}}</div>
          </div>
        </div>
        <div class="contentint3_26">
          <div class="poporinfo3_26">
            <img src="../assets/img/shiliang4.png" alt="" class="img">
            <div class="name">{{info.userName}}</div>
            <div class="textps">性别：{{info.sex==1?'男':'女'}}　|　年龄：{{info.remark}}　|　BMI：{{info.bmi}}</div>
          </div>
          <div class="poporinfo3_26">
            <div class="titlepopor">{{topicpsname}}</div>
            <div class="titlepoportex">{{topicpsnameps}}</div>
          </div>
          <div v-if="topictype==0">
            <div class="topiclist3_26" v-for="(val,index) in msg1">
              <div class="topicli">{{index+1}}、{{val.problem}}</div>
              <div class="topiclips">
                <div class="topiclipsli" v-for="(val1,index1) in val.answer" @click="wenjuantiao(index,index1)">
                  <img src="../assets/img/danxuantrue5_15.png" alt="" class="img" v-if="val1.checked">
                  <img src="../assets/img/danxuanfalse5_15.png" alt="" class="img" v-if="!val1.checked">
                  <div class="texttop">{{val1.name}}</div>
                </div>
              </div>
            </div>
            <div style="width: 100%;float: left;text-align: center;margin:60px 0;">
              <el-button style="width: 100%;background-color: #14C86C;border:none;padding-top:15px;padding-bottom:15px;" type="primary" @click="wenjuanbaogao()" v-loading.fullscreen.lock="fullscreenLoading">提交评估</el-button>
            </div>
          </div>
          <div v-show="topictype!=0">
            <div class="topiclist3_26" v-for="(val,index) in msg2" v-if="topicbu&&topicpstype==1">
              <div class="topicli">{{val.problem}}</div>
              <div class="topiclips">
                <div class="topiclipsli" v-for="(val1,index1) in val.answerList" @click="pinggutiao(index,index1)">
                  <img src="../assets/img/danxuantrue5_15.png" alt="" class="img" v-if="val1.checked!=1">
                  <img src="../assets/img/danxuanfalse5_15.png" alt="" class="img" v-if="val1.checked==1">
                  <div class="texttop">{{val1.name}}</div>
                </div>
              </div>
            </div>
            <div style="width: 100%;float: left;text-align: center;margin:60px 0;" v-if="topicbu&&topicpstype==1">
              <el-button style="width: 100%;background-color: #14C86C;border:none;padding-top:15px;padding-bottom:15px;" type="primary" @click="pingguxia(2)" v-loading.fullscreen.lock="fullscreenLoading">下一步</el-button>
            </div>
            <div v-show="!topicbu">
              <div v-for="(val,index) in msg3">
                <div class="topiclist3_26" v-if="val.type == 2">
                  <div class="topicli">{{val.problem}}</div>
                  <div class="topiclips">
                    <div class="topiclipsli" v-for="(val1,index1) in val.answerList" @click="pinggutiaops(index,index1)">
                      <img src="../assets/img/danxuantrue5_15.png" alt="" class="img" v-if="val1.checked!=1">
                      <img src="../assets/img/danxuanfalse5_15.png" alt="" class="img" v-if="val1.checked==1">
                      <div class="texttop">{{val1.name}}</div>
                    </div>
                  </div>
                </div>
                <div class="topiclist3_26" v-if="val.type != 2">
                  <div class="topicli">{{val.problem}}</div>
                  <div class="topiclips">
                    <el-input style="font-size: 16px;margin-top: 14px;float: left;line-height: 30px;" :placeholder="val.defaultValue" v-model="val.content" type="number" clearable @blur="daxiao(index)">
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%;float: left;text-align: center;margin:60px 0;" v-show="!topicbu&&topicpstype==1">
              <el-button style="width: 48%;background-color: #14C86C;border:none;padding-top:15px;padding-bottom:15px;" type="primary" @click="pingguxia(1)">上一步</el-button>
              <el-button style="width: 48%;background-color: #14C86C;border:none;padding-top:15px;padding-bottom:15px;margin-left: 3%;" type="primary" @click="wenjuaner()" v-loading.fullscreen.lock="fullscreenLoading">提交评估</el-button>
            </div>
            <div style="width: 100%;float: left;text-align: center;margin:60px 0;" v-show="!topicbu&&topicpstype==0">
              <el-button style="width: 100%;background-color: #14C86C;border:none;padding-top:15px;padding-bottom:15px;" type="primary" @click="wenjuaner()" v-loading.fullscreen.lock="fullscreenLoading">提交评估</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;"></div>
    <app-footer />
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'
import { request } from '@/network/request'
export default {
  data() {
    return {
      topicpstype: 1,
      fullscreenLoading: false,
      topicbu: true,
      topictype: null,
      msg: [],
      msg1: [],
      msg2: [],
      msg3: [],
      input: '',
      topicname: '',
      topicpsname: "",
      topicpsnameps: "",
      info: {}

    }
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  methods: {
    wenjuanbaogao() {
      let _this = this;
      _this.fullscreenLoading = true;
      let arr = []
      for (var i = 0; i < _this.msg1.length; i++) {
        for (var s = 0; s < _this.msg1[i].answer.length; s++) {
          if (_this.msg1[i].answer[s].checked) {
            arr.push(_this.msg1[i].answer[s].id)
          }

        }
      }
      if (_this.msg1.length != arr.length) {
        _this.$message({
          offset: 100,
          message: '请完善所有信息！',
          type: 'warning'
        });

        _this.fullscreenLoading = false;
        return
      }



      localStorage.setItem("wenjuan", arr.toString());
      request({
          url: '/report/tWzaiDetailedReport/saveCoronaryDiseaseReport',
          method: 'get',
          params: {
            diseaseType: sessionStorage.getItem('topicps'),
            addType: 4,
            diseaseContents: sessionStorage.getItem('topicpsname'),
            participle: localStorage.getItem("wenjuan")
          }

        })
        .then(function(d) {
          if (d.data.code == 200) {

            localStorage.setItem('baogaoid', d.data.data);
            if(sessionStorage.getItem('topicps') == 64){
               _this.$router.push('zhpdf');
            }else{
              _this.$router.push('pdf');
            }

            _this.fullscreenLoading = false;

          } else {
            _this.fullscreenLoading = false;
          }

        })

    },
    daxiao(n) {
      let _this = this;

      if (_this.msg3[n].content > (+_this.msg3[n].remark.split('-')[1]) || _this.msg3[n].content < (+_this.msg3[n].remark.split('-')[0])) {
        _this.msg3[n].content = '';
        _this.$message({
          offset: 100,
          message: '您输入的数值已超限（' + _this.msg3[n].remark + '）!',
          type: 'warning'
        });
      }
    },
    pingguxia(n) {
      let _this = this;
      if (n == 2) {
        _this.wenjuanyi()

      } else {
        _this.topicbu = true;
      }
      $('body,html').animate({ scrollTop: 0 }, 100);


    },
     wenjuaner() {
     let _this = this,

        arr = [];
      for (var n = 0; n < _this.msg3.length; n++) {
        // 判断是否是单选题
        if (_this.msg3[n].type == 2) {
          let answer = null;
          for (var y = 0; y < _this.msg3[n].answerList.length; y++) {
            // 判断是否选择
            if (_this.msg3[n].answerList[y].checked == 0) {
              answer = _this.msg3[n].answerList[y].name;
              arr.push({
                funcationType: ''+_this.msg3[n].funcationType,
                answer: answer,
              });
            }
          }
        } else{
          if (_this.msg3[n].content != null && _this.msg3[n].content != '') {
            arr.push({
              funcationType: ''+_this.msg3[n].funcationType,
              answer: _this.msg3[n].content,
            });
             // 判断收缩压不能小于舒张压
          if(_this.msg3[n].funcationType == '10001' ||  _this.msg3[n].funcationType == '40106'){

            if(parseFloat(_this.msg3[n].content) <= parseFloat(_this.msg3[n+1].content)){
          _this.$message({
                    offset: 100,
                    message: '收缩压不能小于或等于舒张压',
                    type: 'warning'
                  });
            return
            }
          }
          }
        }
      }
      // arr.length != _this.msg3.length
      console.log(arr.length)
      if (arr.length != _this.msg3.length) {

           _this.$message({
          offset: 100,
          message: '请完善问题,并且填写规范！',
          type: 'warning'
        });
        return
      }
       _this.fullscreenLoading = true;
      request({
        url: '/report/tWzaiDetailedReport/analysis',
        method: 'post',
        data: {
          answer: JSON.stringify(arr),
          isHave: sessionStorage.getItem('topicps'),
          reportId:localStorage.getItem('baogaoid')!='null'?localStorage.getItem('baogaoid'):null
        }
      }).then(res => {
        if (res.data.code == 200) {

          localStorage.setItem('baogaoid', res.data.data);
            _this.$router.push('pdf');

        } else {

        }
        _this.fullscreenLoading = false;
      })

    },
    wenjuanyi() {
      let _this = this,
        arr = [];
      for (var n = 0; n < _this.msg2.length; n++) {
        // 判断是否是单选题
        if (_this.msg2[n].type == 2) {
          let answer = null;
          for (var y = 0; y < _this.msg2[n].answerList.length; y++) {
            // 判断是否选择
            if (_this.msg2[n].answerList[y].checked == 0) {
              answer = _this.msg2[n].answerList[y].name;
              arr.push({
                funcationType: _this.msg2[n].funcationType,
                answer: answer,
              });
            }
          }
        }
      }
      if (arr.length != _this.msg2.length) {
       _this.$message({
          offset: 100,
          message: '请选择问题',
          type: 'warning'
        });
        return
      }
       _this.fullscreenLoading = true;
      request({
        url: '/report/tWzaiDetailedReport/saveStrokeQuestionnaire',
        method: 'post',
        data: {
          answer: JSON.stringify(arr),
          isHave: sessionStorage.getItem('topicps')
        }
      }).then(res => {
        if (res.data.code == 200) {
          localStorage.setItem('baogaoid', res.data.data);
          _this.topicbu = false;
          _this.pinggups();

        } else {

        }
       _this.fullscreenLoading = false;
      })

    },
    pinggutiao(n, s) {
      let _this = this;
      for (var i = 0; i < _this.msg2[n].answerList.length; i++) {
        _this.msg2[n].answerList[i].checked = 1

      }
      _this.msg2[n].answerList[s].checked = 0;

    },
    pinggutiaops(n, s) {
      let _this = this;
      for (var i = 0; i < _this.msg3[n].answerList.length; i++) {
        _this.msg3[n].answerList[i].checked = 1

      }
      _this.msg3[n].answerList[s].checked = 0;

    },
    wenjuantiao(n, s) {
      let _this = this;

      for (var i = 0; i < _this.msg1[n].answer.length; i++) {
        _this.msg1[n].answer[i].checked = false

      }
      _this.msg1[n].answer[s].checked = true;

      // 判断是否您的一级或二级亲属是否曾患恶性肿瘤？
      if(_this.msg1[n].type == 2 && sessionStorage.getItem('topicps') == '64'){
          if(s == 0){
             for(let f = n+1;f<_this.msg1.length; f++){
                for(let q = 0;q < _this.msg1[f].answer.length; q++){
                  if( _this.msg1[f].answer[q].checked == true){
                     _this.msg1[f].answer[q].checked = false;

                  }
                }
            }
          }else{

            for(let f = n;f<_this.msg1.length; f++){
                for(let q = 0;q < _this.msg1[f].answer.length; q++){

                  _this.msg1[f].answer[q].checked = false;
                  if(_this.msg1[f].answer[q].id == 1){
                     _this.msg1[f].answer[q].checked = true;

                  }
                }
            }
          }


      }
    },
    wenjuan() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/startAssessment',
        method: 'get',
        params: { saveId: sessionStorage.getItem('topicps') }
      }).then(res => {
        if (res.data.code == 200) {
          _this.msg1 = res.data.data.problem;


        } else {

        }

      })

    },
    pinggu() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/getQuestionnaire',
        method: 'get',
        params: { isHave: sessionStorage.getItem('topicps') }
      }).then(res => {
        if (res.data.code == 200) {
          _this.topicbu = true;
          _this.msg2 = res.data.data.problemList;


        } else {

        }

      })

    },
    pinggups() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/getProblem',
        method: 'get',
        params: { isHave: sessionStorage.getItem('topicps') }
      }).then(res => {
        if (res.data.code == 200) {
           _this.topicbu = false;
          _this.msg3 = res.data.data.problemList;


        } else {

        }

      })

    },
    tiao(n) {
      let _this = this;
      for (var i = 0; i < _this.msg.length; i++) {
        if (_this.msg[i].funcationType == n) {
          _this.msg[i].deafultChoose = true;
          _this.topicpsname = _this.msg[i].funcationName;
          _this.topicpsnameps = _this.msg[i].reportIntroduce;
          _this.topicpstype = _this.msg[i].haveQue;
          sessionStorage.setItem('topicps', n);
          sessionStorage.setItem('topicpsname', _this.topicpsname);
          if (_this.topictype == 0) {
               _this.wenjuan();
            } else {
              if (_this.topicpstype == 1) {
                _this.pinggu();
              } else {
                _this.pinggups();

              }


            }

        } else {
          _this.msg[i].deafultChoose = false;
        }

      }

    },
    returnGo() {
      this.$router.go(0);
    },
    Scroll() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 400) {
        //$('.header-1').fadeIn("slow");
        $(".pageScroll").addClass("pageshow");
      } else if (scrollTop < 400) {
        $(".pageScroll").removeClass("pageshow");
      }
    },
  },
  mounted() {
    let _this = this;

    $(".nav-warp").addClass("tophaeader");
    _this.topicname = sessionStorage.getItem('topicname');
    _this.topictype = sessionStorage.getItem('topic')
    request({
      url: '/report/tWzaiDetailedReport/cardiocerebrovascular',
      method: 'get',
      params: { types: sessionStorage.getItem('topic') }
    }).then(res => {
      if (res.data.code == 200) {
        _this.msg = res.data.data;
        for (var i = 0; i < _this.msg.length; i++) {
          if (_this.msg[i].deafultChoose) {
            _this.topicpsname = _this.msg[i].funcationName;
            _this.topicpsnameps = _this.msg[i].reportIntroduce;
            _this.topicpstype = _this.msg[i].haveQue;
            sessionStorage.setItem('topicps', _this.msg[i].funcationType);

            sessionStorage.setItem('topicpsname', _this.topicpsname);
          }

        }
        if (_this.topictype == 0) {
          _this.wenjuan();
        } else {

          if (_this.topicpstype == 1) {
            _this.pinggu();
          } else {
            _this.pinggups();
          }


        }

      } else {

      }

    })


    request({
      url: '/system/user/profile/userInfo',
      method: 'get',
      params: {}
    }).then(res => {
      if (res.data.code == 200) {
        _this.info = res.data.data;
      } else {

      }

    })





  },
}

</script>
<style>
.el-loading-mask {
    background-color:rgba(255,255,255,.6);
}
.zhanshibox3_25 {
  width: 100%;
  height: 100%;
  background-color: #F3F5F7;
  float: left;
  margin-top: 64px;
}

.zhanshi3_25 {
  width: 1140px;
  height: 100%;
  margin: 0 auto;
}

.zhanshi3_25 .toptitle {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-top: 90px;
}

.toptitleul3_26 {
  width: 100%;
  float: left;
  margin: 60px 0;
}

.toptitleul3_26 .liinttrue {
  cursor: pointer;
  padding: 16px 20px;
  float: left;
  margin-right: 40px;
  background: #14C86C;
  border: 1px solid #14C86C;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
   margin-bottom: 20px;
}

.toptitleul3_26 .liinttrue:nth-last-child(1),
.toptitleul3_26 .liintfalse:nth-last-child(1) {
  margin-right: 0;
}

.toptitleul3_26 .liintfalse {
  cursor: pointer;
  padding: 16px 20px;
  float: left;
  margin-right: 40px;
  background: #fff;
  border: 1px solid #E0E0E0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000;
  border-radius: 5px;
  margin-bottom: 20px;
}

.contentint3_26 {
  width: 100%;
  float: left;
  background-color: #fff;
  border-radius: 10px;
  padding: 0 170px;
  box-sizing: border-box;
  border: 1px solid #E6E6E6;
  margin-bottom: 100px;
}

.poporinfo3_26 {
  width: 100%;
  float: left;
  border-bottom: 1px solid #E6E6E6;
}

.poporinfo3_26 .img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 100px;
  margin: 30px 0;
}

.poporinfo3_26 .name {
  width: 100px;
  height: 48px;
  line-height: 48px;
  float: left;
  border-radius: 100px;
  margin: 30px 20px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
}

.poporinfo3_26 .textps {
  width: 500px;
  float: right;
  line-height: 108px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: right;
}

.poporinfo3_26 .titlepopor {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-top: 60px;
}

.poporinfo3_26 .titlepoportex {
  width: 100%;
  float: left;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin: 24px 0;
}

.topiclist3_26 {
  width: 100%;
  float: left;
  margin-top: 30px;
}

.topiclist3_26 .topicli {
  width: 100%;
  float: left;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 24px;
}

.topiclist3_26 .topiclips {
  width: 100%;
  float: left;
  padding-left: 26px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.topiclips .el-input__inner {
  border: none;
  border-bottom: 1px solid #DCDFE6;
  border-radius: 0;
}

.topiclist3_26 .topiclipsli {
  width: 100%;
  height: 16px;
  float: left;
  margin-top: 14px;
}

.topiclist3_26 .topiclipsli .img {
  width: 16px;
  height: 16px;
  float: left;
}

.topiclist3_26 .topiclipsli .texttop {
  width: 700px;
  float: left;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-left: 20px;
  line-height: 16px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/topic.vue